import BaseFactory from 'services/sports/default/base-factory';
import Const from 'constants';
import LineupClassic from './lineup-classic';
import LineupShowdown from './lineup-showdown';
import LineupTiers from './lineup-tiers';

const classesMap = {
    [Const.GAME_TYPE_CLASSIC]: LineupClassic,
    [Const.GAME_TYPE_SHOWDOWN]: LineupShowdown,
    [Const.GAME_TYPE_TIERS]: LineupTiers,
};

class Factory extends BaseFactory {
    createObj(objectName, params) {
        const {sportConfig} = params;
        const gameType = sportConfig.getGameType();

        if (gameType in classesMap) {
            return new classesMap[gameType](params);
        }

        throw new Error(`Unknown gameType "${gameType}".`);
    }
}

export {Factory};
